function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_21_"
}, React.createElement("path", {
  fill: "currentcolor",
  id: "XMLID_28_",
  className: "st0",
  d: "M414,302.6c-3.1-1.8-5.6-3.1-9.9-3.9v-97.5c4.3-0.8,6.9-2.1,10-3.9 c17.5-10.2,23.6-32.5,13.5-50c-10.2-17.5-32.4-23.5-49.9-13.4c-3.1,1.8-5.9,4.1-8.3,6.6l-84.4-48.7c1-3.3,1.5-6.8,1.5-10.5 c0-20.2-16.3-36.6-36.6-36.6s-36.6,16.3-36.6,36.6c0,3.6,0.5,7.1,1.5,10.4l-84.4,48.7c-2.4-2.5-5.1-4.7-8.3-6.5 c-17.5-10.1-39.9-4.1-50,13.4c-10.1,17.5-3.8,39.9,13.7,50c3.1,1.8,5.7,3.1,10,3.9v97.5c-4.3,0.8-6.8,2.1-9.9,3.9 c-17.5,10.2-23.6,32.5-13.5,50c10.1,17.5,32.3,23.5,49.9,13.4c3.1-1.8,5.8-4,8.2-6.4l84.3,48.7c-1,3.3-1.5,6.8-1.5,10.3 c0,20.2,16.3,36.6,36.6,36.6c20.2,0,36.6-16.5,36.6-36.6c0-4-0.6-7.9-1.8-11.5l83.9-48.4c2.5,2.8,5.6,5.3,9,7.3 c17.5,10.1,39.8,4.1,49.9-13.4C437.7,335.1,431.6,312.8,414,302.6z M114.4,299.2c-0.5-0.1-1.3-0.3-1.3-0.4v-97.6 c8.6-2.3,17.6-8.3,22.7-17.2c5.1-8.9,6-19.1,3.4-28.3l84.5-48.8c0.3,0.4,0.7,0.7,1.1,1L114.4,299.2z M277.1,394 c-6.7-7.3-16.3-11.9-27-11.9c-10.4,0-19.7,4.3-26.3,11.2l-84.4-48.8c0.1-0.5,0.3-1.4,0.4-1.4h220.8c0.2,1.4,0.4,1.6,0.7,2.4 L277.1,394z M364.3,316.1c-1.8,3.1-3.1,6.9-3.9,9.7H139.7c-0.8-2.9-2.1-6.6-3.9-9.7c-1.8-3.1-4-5.9-6.4-8.2l110.5-191.3 c3.2,0.9,6.7,1.4,10.2,1.4c3.5,0,7-0.5,10.2-1.4l110.4,191.3C368.2,310.2,366.1,313,364.3,316.1z M387,298.8c0,0.1-0.8,0.2-1.3,0.4 L275.3,107.8c0.3-0.3,0.7-0.6,1-1l84.6,48.8c-2.6,9.2-1.8,19.4,3.4,28.3c5.1,9,14.2,14.9,22.7,17.2V298.8z"
}));

var SvgGraphQl01 = function SvgGraphQl01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGraphQl01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GraphQL-01.77b25dca.svg";
export { ForwardRef as ReactComponent };